var map = {
	"./template-1/lottery/lottery": "app/styles/client/templates/template-1/lottery/lottery",
	"./template-10/lottery/lottery": "app/styles/client/templates/template-10/lottery/lottery",
	"./template-11/lottery/lottery": "app/styles/client/templates/template-11/lottery/lottery",
	"./template-2/lottery/lottery": "app/styles/client/templates/template-2/lottery/lottery",
	"./template-3/lottery/lottery": "app/styles/client/templates/template-3/lottery/lottery",
	"./template-4/lottery/lottery": "app/styles/client/templates/template-4/lottery/lottery",
	"./template-5/lottery/lottery": "app/styles/client/templates/template-5/lottery/lottery",
	"./template-6/lottery/lottery": "app/styles/client/templates/template-6/lottery/lottery",
	"./template-7/lottery/lottery": "app/styles/client/templates/template-7/lottery/lottery",
	"./template-8/lottery/lottery": "app/styles/client/templates/template-8/lottery/lottery",
	"./template-9/lottery/lottery": "app/styles/client/templates/template-9/lottery/lottery"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 483;